import { FormEvent, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Input from '../../../../common/input';
import MessageError from '../../../../common/message-error';
import l from '../../../../../lang';
import { usePayouts } from '../../../../../store/payouts';

import '../styles.scss';

interface OTPModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const OTPModal = ({ open, onClose, onSuccess }: OTPModalProps) => {
  const { createPayout, confirmPayout } = usePayouts();
  const [otpCode, setOtpCode] = useState('');

  useEffect(() => {
    if (createPayout.confirm.success && open) {
      onSuccess();
    }
  }, [createPayout.confirm.success, open]);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (!otpCode || otpCode.length < 6) {
      return;
    }
    confirmPayout(otpCode);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{l('payouts.create.otp.title')}</DialogTitle>
        <DialogContent>
          <p className="payout-create__otp-description">{l('payouts.create.otp.description')}</p>
          <Input
            name="otpCode"
            label={l('payouts.create.otp.inputLabel')}
            value={otpCode}
            onChange={event => setOtpCode(event.target.value.replace(/\D/g, '').slice(0, 6))}
            maxLength={6}
            error={otpCode.length > 0 && otpCode.length < 6 ? l('payouts.create.otp.error') : ''}
          />
          <br />
          {createPayout.confirm.error && <MessageError errorInfo={createPayout.confirm.errorInfo} />}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{ backgroundColor: '#E8E8E8', color: 'black', ':hover': { backgroundColor: '#D0D0D0' } }}
          >
            {l('common.cancel')}
          </Button>
          <Button type="submit" variant="contained" disabled={createPayout.confirm.loading || otpCode.length < 6}>
            {l('payouts.create.otp.confirm')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default OTPModal;
